
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 43 43","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"21.5","cy":"21.5","r":"21.5","fill":"#4FB999"}}),_c('path',{attrs:{"d":"M11 22l7 7 15.5-15.5","stroke":"#fff","stroke-width":"3","stroke-linecap":"round"}})])
          )
        }
      }
    